
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'lodash/isFunction';
import { T as TRIGGER_SIZE_MAP } from './multiselect-helper-mixin.js';

var script = {
  components: {
    PendoIcon
  },
  props: {
    activate: {
      type: Function
    },
    computedPlaceholder: {
      type: [String, Object, Number]
    },
    deactivate: {
      type: Function
    },
    disabled: {
      type: Boolean
    },
    handleKeydown: {
      type: Function
    },
    id: {
      type: String
    },
    inputValue: {
      type: String
    },
    isFullWidth: {
      type: Boolean
    },
    isOpen: {
      type: Boolean
    },
    isSearchable: {
      type: Boolean
    },
    isSearchIconVisible: {
      type: Boolean
    },
    minTriggerWidth: {
      type: [String, Number]
    },
    multiple: {
      type: Boolean
    },
    shouldAnimateSearchEnterExit: {
      type: Boolean
    },
    taggable: {
      type: Boolean
    },
    triggerSize: {
      type: String
    },
    triggerWidth: {
      type: Number
    },
    updateInputValue: {
      type: Function
    }
  },

  data() {
    const initialMinWidth = parseInt(this.minTriggerWidth) - TRIGGER_SIZE_MAP[this.triggerSize] - 30;
    return {
      inputMinWidth: initialMinWidth,
      inputWidth: initialMinWidth
    };
  },

  computed: {
    inputStyles() {
      if (this.isFullWidth) {
        return {
          width: `${this.inputWidth}px`
        };
      }

      return {
        minWidth: `${this.inputMinWidth}px`,
        width: `${this.inputWidth}px`
      };
    },

    searchIconTransition() {
      if (this.shouldAnimateSearchEnterExit) {
        return 'pendo-multiselect-search-icon-fade-scale';
      }

      return '';
    },

    searchInputTransition() {
      if (this.shouldAnimateSearchEnterExit) {
        return 'pendo-multiselect-search-input-slide';
      }

      return '';
    }

  },

  mounted() {
    if (this.$refs.input) {
      requestAnimationFrame(() => {
        this.$refs.input.focus();
      });
    }

    this.setInputWidth();
  },

  methods: {
    setInputWidth() {
      const _this$$refs = this.$refs,
            input = _this$$refs.input,
            mirror = _this$$refs.mirror;

      if (input && mirror && this.isOpen) {
        const _window$getComputedSt = window.getComputedStyle(input),
              fontSize = _window$getComputedSt.fontSize,
              fontFamily = _window$getComputedSt.fontFamily,
              fontWeight = _window$getComputedSt.fontWeight,
              fontStyle = _window$getComputedSt.fontStyle,
              letterSpacing = _window$getComputedSt.letterSpacing,
              textTransform = _window$getComputedSt.textTransform,
              minWidth = _window$getComputedSt.minWidth,
              maxWidth = _window$getComputedSt.maxWidth;

        Object.assign(mirror.style, {
          fontSize,
          fontFamily,
          fontWeight,
          fontStyle,
          letterSpacing,
          textTransform,
          minWidth,
          maxWidth
        });
        const suffixSize = TRIGGER_SIZE_MAP[this.triggerSize] - 2;
        this.inputWidth = this.isFullWidth ? this.$el.closest('.pendo-multiselect__value').clientWidth - 22 : Math.max(this.triggerWidth - suffixSize - 30, mirror.getBoundingClientRect().width - 22);
      }
    },

    beforeLeave(el) {
      el.style.display = 'none';
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-multiselect__control",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.searchIconTransition,
      "appear": ""
    },
    on: {
      "before-leave": _vm.beforeLeave
    }
  }, [_vm.isSearchIconVisible ? _c('div', {
    staticClass: "pendo-multiselect__search-icon-wrapper"
  }, [_c('pendo-icon', {
    staticClass: "pendo-multiselect__search-icon",
    attrs: {
      "type": "search",
      "size": "14"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.searchInputTransition,
      "appear": ""
    },
    on: {
      "before-leave": _vm.beforeLeave
    }
  }, [_c('div', {
    staticClass: "pendo-multiselect__input-wrapper"
  }, [_c('input', {
    ref: "input",
    staticClass: "pendo-multiselect__input",
    style: _vm.inputStyles,
    attrs: {
      "id": _vm.id,
      "autocapitalize": "none",
      "autocorrect": "off",
      "autocomplete": "off",
      "spellcheck": "false",
      "aria-autocomplete": "list",
      "type": "text",
      "placeholder": _vm.computedPlaceholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        $event.preventDefault();
        return _vm.$emit('up');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        $event.preventDefault();
        return _vm.$emit('down');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) {
          return null;
        }

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.$emit('delete');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.stopPropagation();

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.$emit('enter', $event);
      }],
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.$emit('tab');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.$emit('esc');
      }],
      "input": function ($event) {
        return _vm.updateInputValue($event.target.value);
      }
    }
  }), _vm._v(" "), _c('span', {
    ref: "mirror",
    staticClass: "pendo-multiselect__input-mirror",
    domProps: {
      "textContent": _vm._s(_vm.computedPlaceholder)
    }
  })])])], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-multiselect-input.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoMultiselectInput = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoMultiselectInput;
